module.exports = __webpack_public_path__ + "img/solution2.97594107.png";